<template>
  <div class="leaderboard-table">
    <!-- Table Header -->
    <div class="table-header">
      <div class="header-cell rank-header">Rank</div>
      <div class="header-cell user-header">Explorer</div>
      <div class="header-cell score-header">Score</div>
    </div>

    <!-- Table Body -->
    <div class="table-body">
      <LeaderboardUserRow
        v-for="entry in entries"
        :key="entry.user_id"
        :entry="entry"
        :current-user-id="currentUserId"
        :show-country="showCountry"
      />
    </div>
  </div>
</template>

<script>
import LeaderboardUserRow from './LeaderboardUserRow.vue'

export default {
  name: 'LeaderboardTable',
  components: {
    LeaderboardUserRow
  },
  props: {
    entries: {
      type: Array,
      required: true
    },
    currentUserId: {
      type: String,
      default: null
    },
    showCountry: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.leaderboard-table {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.table-header {
  display: grid;
  grid-template-columns: 80px 1fr 120px;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 0.875rem;
}

.header-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rank-header {
  justify-content: center;
}

.score-header {
  justify-content: flex-end;
}

.table-body {
  max-height: 600px;
  overflow-y: auto;
}

/* Custom scrollbar */
.table-body::-webkit-scrollbar {
  width: 8px;
}

.table-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-body::-webkit-scrollbar-thumb {
  background: #667eea;
  border-radius: 4px;
}

.table-body::-webkit-scrollbar-thumb:hover {
  background: #764ba2;
}

/* Mobile - hide table on mobile, use cards instead */
@media (max-width: 768px) {
  .leaderboard-table {
    display: none;
  }
}
</style>
